<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../../editable';
	import type { SbColor } from '../../types';
	import { getFontColor, getSecondaryFontColor } from './helpers';

	interface Props {
		content: ISbStoryData<{
			color: Extract<SbColor, 'brown-6' | 'green-1' | 'green-2' | 'green-3' | 'green-6'>;
			eyebrow: string;
			value: string;
			unit: string;
			description: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div
	use:editable={content}
	class={[
		'flex flex-col rounded-xl p-4 lg:p-6',
		`bg-${content.color}`,
		getFontColor(content.color)
	]}
>
	<header
		class="text-[12px]/[140%] font-semibold uppercase tracking-[.96px] opacity-80 lg:text-[14px]/[140%]"
	>
		{content.eyebrow}
	</header>
	<div
		class={[
			'mb-3 mt-7 flex items-baseline gap-x-1 font-serif text-[40px]/[120%] tracking-[-1.2px] lg:mb-5 lg:mt-12 lg:text-[48px]/[120%] lg:tracking-[-1.44px]',
			getSecondaryFontColor(content.color)
		]}
	>
		{content.value}
		<span class="text-[28px]/[110%] tracking-[-.28px] lg:text-[32px]/[110%] lg:tracking-[-.32px]"
			>{content.unit}</span
		>
	</div>
	<p class="text-balance text-[12px]/[160%] lg:text-[14px]/[160%]">
		{content.description}
	</p>
</div>
